import React from "react";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import {
  Hero,
  VanShowcase,
  Benefits,
  OurStory,
  Blog,
  CTABanner,
  ContactForm,
} from "../components/landing";
import { SEO, generateLocalBusinessSchema, generateBreadcrumbSchema } from "../seo";
import { useTranslation } from "../hooks/useTranslation";

const Landing = () => {
  const { t } = useTranslation('home');
  const schemas = [
    generateLocalBusinessSchema(),
    generateBreadcrumbSchema([{ name: 'Home', path: '' }]),
  ];

  return (
    <div className="landing-container">
      <SEO schema={schemas} />
      <h1 className="sr-only">{t('seo.h1', 'Campervan Rental in Portugal - SunCatchers')}</h1>
      <div className="landing-content">
        <Header />
        <Hero />
        <div className="van-showcase-benefits">
          <VanShowcase />
          <Benefits />
        </div>
        <OurStory />
        <div className="blog-cta-contact">
          <div className="blog-cta-container">
            <Blog />
            <CTABanner />
            <ContactForm />
          </div>
          <CheckoutFooter />
        </div>
      </div>
    </div>
  );
};

export default Landing;
